<!-- Explanation about (mouseleave) handlers:

In this component, the tooltip is always available for hovering.

When `freezeOnHover` is set to `true`, we must attach a `(mouseleave)` handler
directly to the tooltip component to hide it when the mouse leaves.

However, since the tooltip has a delay before appearing, the user might move the mouse
away before it becomes visible. In that case, we also need a `(mouseleave)` handler
on the text container to cancel the tooltip appearance.

So, we attach the `(mouseleave)` to the text div when the tooltip is not yet visible.
-->
<div
  #divWithText
  class="truncated"
  [id]="id"
  [attr.data-qa]="dataQA"
  [style.-webkit-line-clamp]="linesCount"
  (mouseenter)="activateTooltip()"
  (mouseleave)="!tooltip && deactivateTooltip()">
  {{text}}
</div>

@if (tooltipSettings.show) {
  <app-tooltip
    #tooltip
    [text]="tooltipSettings.text"
    [coordinates]="tooltipSettings.coordinates"
    [xShift]="xShift"
    [yShift]="yShift"
    [isParentPositionRelative]="true"
    [freezeOnHover]="true"
    [isCopyTextOnHoverClick]="true"
    [hasScroll]="true"
    [positionType]="positionType"
    (mouseleave)="deactivateTooltip()"
    />
}
